import { render, staticRenderFns } from "./delivery-plan-products.vue?vue&type=template&id=b56ace56&scoped=true&"
import script from "./delivery-plan-products.vue?vue&type=script&lang=js&"
export * from "./delivery-plan-products.vue?vue&type=script&lang=js&"
import style0 from "./delivery-plan-products.vue?vue&type=style&index=0&id=b56ace56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56ace56",
  null
  
)

export default component.exports